import { useMemo, useState } from "react";
import { Button, Popup } from "semantic-ui-react";

import { Option } from "models/Option";
import { SelectedCarrier } from "models/SelectedCarrier";
import { useGetCarrierCapacities } from "./hooks/useGetCarrierCapacities";
import CarrierCapacityShipmentMatchModal from "./matches/CarrierCapacityShipmentMatchModal";

import styles from "./CarrierCapacity.module.scss";

type CarrierCapacityShipmentMatchesProps = {
  equipmentOptions: Option<number>[];
  carrier: SelectedCarrier;
  capacities: ReturnType<
    typeof useGetCarrierCapacities<"Capacity" | "NoCapacity">
  >;
  preferredLanes: ReturnType<typeof useGetCarrierCapacities<"Preferred Lane">>;
};

const CarrierCapacityShipmentMatches = (
  props: CarrierCapacityShipmentMatchesProps
) => {
  const [isMatchingCapacity, setIsMatchingCapacity] = useState(false);

  const {
    carrier: { isDoNotUse },
    capacities,
    preferredLanes,
  } = props;

  const popupContent = useMemo(() => {
    if (isDoNotUse) {
      return 'Carrier is marked "Do Not Use"';
    } else if (
      capacities.data &&
      capacities.data.length === 0 &&
      preferredLanes.data &&
      preferredLanes.data.length === 0
    ) {
      return "Requires at least one Capacity or Preferred Lane";
    }

    return null;
  }, [capacities, preferredLanes, isDoNotUse]);

  return (
    <div className={styles.carrierCapacityShipmentMatches}>
      <header>
        <h2>Shipments</h2>

        <Popup
          wide
          disabled={!popupContent}
          trigger={
            <div>
              <Button
                color="green"
                disabled={!!popupContent}
                onClick={() => setIsMatchingCapacity(true)}
              >
                Find Shipments
              </Button>
            </div>
          }
          content={popupContent}
        />
      </header>

      {isMatchingCapacity ? (
        <CarrierCapacityShipmentMatchModal
          {...props}
          onClose={() => setIsMatchingCapacity(false)}
        />
      ) : null}
    </div>
  );
};

export default CarrierCapacityShipmentMatches;
